import { showValidateError } from "@/plugins/validateErrorHandler";
import Vue from "vue";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export default {
  actions: {
    //@ts-ignore
    errorException(ctx: any, { error }) {
      const vm = new Vue({});
      if (error?.status === 400 && error.data.violations) {
        vm.$bvToast.toast(showValidateError(error.data.violations), {
          variant: "danger",
          title: i18n.tc(LocalesFields.Error)
        });
      } else {
        vm.$bvToast.toast(error?.data.message, {
          variant: "danger",
          title: i18n.tc(LocalesFields.Error)
        });
      }
    },
    //@ts-ignore
    successToast(ctx: any, { message }) {
      const vm = new Vue({});
      vm.$bvToast.toast(message, {
        variant: "success",
        title: i18n.tc(LocalesFields.Success)
      });
    },
    //@ts-ignore
    localError(ctx: any, message) {
      const vm = new Vue({});
      vm.$bvToast.toast(message, {
        variant: "danger",
        title: i18n.tc(LocalesFields.Error)
      });
    }
  }
};
